<div class="layout--header">
  <app-header-logged></app-header-logged>
</div>
<div class="aaaasf-main">
  <div class="aaaasf-side-menu">
    <app-side-menu></app-side-menu>
  </div>
  <div class="aaaasf-container">
    <div class="layout--router">
      <div class="outlet-container">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>
